import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { WhatsAppIcon } from "./Reveal";
import { wa, WA_MSG, scrollToSection } from "../constants/site";

const LINKS = [
    { label: "Benefícios", hash: "#beneficios" },
    { label: "Catálogo", hash: "#catalogo" },
    { label: "Planos", hash: "#planos" },
    { label: "FAQ", hash: "#faq" },
    { label: "Contato", hash: "#contato" },
];

const go = (e, hash) => {
    e.preventDefault();
    scrollToSection(hash);
};

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header
            className="fixed inset-x-0 top-0 z-50 border-b border-[#222232] bg-[#070709]/80 backdrop-blur-xl"
            data-testid="navbar"
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8">
                <Logo light />

                <nav className="hidden items-center gap-7 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.hash}
                            href={l.hash}
                            data-testid={`nav-link-${l.hash.slice(1)}`}
                            onClick={(e) => go(e, l.hash)}
                            className="text-sm font-semibold text-[#94A3B8] transition-colors hover:text-white"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <span className="hidden items-center gap-2 rounded-full border border-[#222232] bg-[#0E0E14] px-3 py-1.5 text-xs font-semibold text-[#94A3B8] lg:flex">
                        <span className="h-2 w-2 rounded-full bg-[#25D366] animate-pulse-dot" />
                        Sinal online
                    </span>
                    <a
                        href={wa(WA_MSG.trial)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="nav-cta-whatsapp"
                        className="hidden items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-bold text-white shadow-lg shadow-[#25D366]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1fb857] md:inline-flex"
                    >
                        <WhatsAppIcon className="h-4 w-4" />
                        Teste grátis
                    </a>
                    <button
                        className="grid h-10 w-10 place-items-center rounded-full border border-[#222232] bg-[#0E0E14] text-white md:hidden"
                        onClick={() => setOpen((v) => !v)}
                        data-testid="nav-mobile-toggle"
                        aria-label="Abrir menu"
                    >
                        {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden border-t border-[#222232] bg-[#070709] md:hidden"
                        data-testid="nav-mobile-menu"
                    >
                        <div className="space-y-1 px-5 py-4">
                            {LINKS.map((l) => (
                                <a
                                    key={l.hash}
                                    href={l.hash}
                                    data-testid={`nav-mobile-link-${l.hash.slice(1)}`}
                                    onClick={(e) => {
                                        setOpen(false);
                                        go(e, l.hash);
                                    }}
                                    className="block rounded-xl px-4 py-3 font-semibold text-white transition-colors hover:bg-[#14141E]"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href={wa(WA_MSG.trial)}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="nav-mobile-cta-whatsapp"
                                className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3.5 font-bold text-white"
                            >
                                <WhatsAppIcon className="h-5 w-5" />
                                Teste grátis no WhatsApp
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};
